import { FormControl, FormGroup } from '@angular/forms';
import { MasterHelper } from './../../../core/utilities/master-helper';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DateRangeView } from 'src/app/core/models/view-model/date-range-view-model';

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss']
})
export class DateRangePickerComponent implements OnInit {

  @Output() DatePickerOutput = new EventEmitter<any>();
  datePickerGroup: FormGroup;
  dateRange: DateRangeView;

  constructor() {
    this.dateRange = new DateRangeView();
    this.datePickerGroup = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
    });
  }

  ngOnInit(): void {
  }

  onChange(event: any): void {
    if (event.target.value) {
      this.DatePickerOutput.emit(this.dateRange);
    }
  }

  onClick(): void {
    this.dateRange = new DateRangeView();
    this.DatePickerOutput.emit(this.dateRange);
  }
}
